import { Component, OnChanges, Input, SimpleChanges } from '@angular/core';
import { AChatroom } from '../../class/ana-chatroom';
import { EchartsOptionProvider } from '../../providers/echarts-option/echarts-option';
import { ChatroomProvider } from '../../providers/chatroom/chatroom';
import { HttpProvider } from '../../providers/http/http';
// import {BaseConfigProvider} from "../../providers/base-config/base-config";
// declare var _hmt:any;

/**
 * Generated class for the ChatroomPortraitComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'chatroom-portrait',
  templateUrl: 'chatroom-portrait.html',
})
export class ChatroomPortraitComponent implements OnChanges {
  text: string;

  @Input() chatroom: AChatroom;

  relation_option = this.echatrsOption.getRelation([], []);

  china_option = this.echatrsOption.getChinaOption([]);

  gender_change = this.echatrsOption.getGenderChange([], []);

  choosed_scope;
  scopes = [
    { name: '近7天', value: 3 },
    { name: '近30天', value: 4 },
  ];

  constructor(
    private chatroomService: ChatroomProvider,
    private echatrsOption: EchartsOptionProvider,
    public http: HttpProvider
  ) {
    this.provinces = ['北京','安徽','澳门', '重庆', '福建', '甘肃', '广东', '广西', '贵州', '海南', '河北', '河南', '黑龙江', '湖北', '湖南', '吉林', '江苏', '江西', '辽宁', '内蒙古', '宁夏', '青海', '山东', '山西', '陕西', '上海', '四川', '台湾', '天津', '西藏', '香港', '新疆', '云南', '浙江'];
    this.choosed_scope = this.scopes[0];

  }
  active_rate_line = this.echatrsOption.getActiveRateLine([]);
  ngOnChanges(change: SimpleChanges) {
    this.init_page();
    this.getGeoData();
    this.getGender();
    // this.getGender();
    // this.getGeoData();
  }

  changeScope(index){
      this.choosed_scope = this.scopes[index];
      this.init_page();
  }

  init_page() {
    // this.getLifeCycle();
    // this.changeActiveScope(7);
    // this.getRelation();
    // this.getPhoneRate();
    // this.changeMessageScope(7);
    // this.getGender();
    // this.getGeoData();
    // this.getExceptionsList();
    // this.getActiveLineAll();
    this.getPeriodData();
    this.getTrendData();

  }
  data_list = [
    {
      name:'发言数',
      value:'speak_list'
    },
    {
      name:'活跃人数',
      value:'active_list'
    }
  ];

  trend_data_list = [
    {
      name:'发言数',
      value:'speak_list'
    },
    {
      name:'活跃人数',
      value:'activity_list'
    },
    {
      name:'邀请数',
      value:'invited_list'
    }
  ];

  periodDataIndex = 0;
  toggleItem(index){
    if(this.periodDataIndex != index){
      this.periodDataIndex = index;
      if(this.periodData){
        this.getPeriodOption()
      }
    }
  }



  period_option = {};

  is_loading_period;
  is_error_period;
  periodData;
  getPeriodData(){
    this.is_loading_period = true;
    this.is_error_period = false;
    this.chatroomService.getPeriodData(this.chatroom.chatroomname,this.choosed_scope.value).subscribe(res => {
      this.is_loading_period = false;
      this.is_error_period = false;
      //TODO:main function
      this.periodData = res['content'];
      this.getPeriodOption();

    },
    err => {
      this.is_loading_period = false;
      this.is_error_period = true;
    })
  }

  getPeriodOption(){
    let line1;
    let line2;
    if(this.periodDataIndex == 1){
      line1 = this.periodData['activity_avg_list'];
      line2 = this.periodData['activity_today_list']
    }
    else {
      line1 = this.periodData['speak_avg_list'];
      line2 = this.periodData['speak_today_list']
    }
    this.period_option = this.echatrsOption.getPeriodOption(this.periodDataIndex,line1,line2);
  }


  is_loading_trend;
  is_error_trend;
  trend_option = {};
  trendData;
  getTrendData(){
    this.is_loading_trend = true;
    this.is_error_trend = false;
    this.chatroomService.getTrendData(this.chatroom.chatroomname,this.choosed_scope.value).subscribe(res => {
      this.is_loading_trend = false;
      this.is_error_trend = false;
      //TODO:main function
      this.trendData = res['content'];
      this.getTrendOption();
    },
    err => {
      this.is_loading_trend = false;
      this.is_error_trend = true;
    })
  }

  getTrendOption(){
    let chooseItem = this.trend_data_list[this.trendDataIndex];
    this.trend_option = this.echatrsOption.getTrendOption(chooseItem.name,this.trendData[chooseItem.value]);
  }
  trendDataIndex = 0;
  toggleTrendItem(index){
    if(this.trendDataIndex != index){
      this.trendDataIndex = index;
      if(this.trendData){
        this.getTrendOption()
      }
    }
  }

  // active_scope;
  // changeActiveScope(day) {
  //   if (this.active_scope != day) {
  //     this.active_scope = day;
  //     this.getActiveRate();
  //   }
  // }
  //
  // is_loading_active_rate;
  // is_error_active_rate;
  // active_data;
  // getActiveRate() {
  //   this.is_loading_active_rate = true;
  //   this.is_error_active_rate = false;
  //   this.chatroomService
  //     .getActiveRate(this.chatroom.chatroom_id, this.active_scope)
  //     .subscribe(
  //       res => {
  //         this.is_loading_active_rate = false;
  //         this.is_error_active_rate = false;
  //         //TODO:main function
  //         this.active_data = res['content']['active_rate_list'];
  //         this.active_rate_line = this.echatrsOption.getActiveRateLine(
  //           this.active_data
  //         );
  //       },
  //       err => {
  //         this.is_loading_active_rate = false;
  //         this.is_error_active_rate = true;
  //         // this.http.errCatch(err);
  //       }
  //     );
  // }

  // is_loading_message_rate;
  // is_error_message_rate;
  // message_rate = this.echatrsOption.getMessageBar([]);
  // message_scope;
  // message_num;
  // message_time = [];
  // changeMessageScope(scope) {
  //   if (this.message_scope != scope) {
  //     this.message_scope = scope;
  //     this.getMessageTendency();
  //     this.getMessageComponent();
  //   }
  // }
  //
  // getMessageTendency() {
  //   this.is_loading_message_rate = true;
  //   this.is_error_message_rate = false;
  //   this.chatroomService
  //     .getMessageTendency(this.chatroom.chatroom_id, this.message_scope)
  //     .subscribe(
  //       res => {
  //         this.is_loading_message_rate = false;
  //         this.is_error_message_rate = false;
  //         //TODO:main function
  //         // this.msg_list = res['content']['msg_component'];
  //         // this.msg_index = res['content']['index'];
  //         // this.message_rate = this.echatrsOption.getMessageRate(this.msg_list);
  //         let top = this.message_scope > 7 ? 2 : 0;
  //         let message_top = res['content']['msg_count_list']
  //           .slice(0)
  //           .sort((a, b) => b - a)[top];
  //
  //         this.message_rate = this.echatrsOption.getMessageBar(
  //           res['content']['msg_count_list'],
  //           message_top
  //         );
  //         this.message_num = this.message_rate.series[0].data.filter(
  //           item => item > 0
  //         ).length;
  //         if (this.message_scope == 30) {
  //           this.message_time = [];
  //           res['content']['msg_count_list'].forEach((item, i) => {
  //             if (item >= message_top && item > 0) {
  //               this.message_time.push(
  //                 new Date().getTime() - (30 - i) * 24 * 60 * 60 * 1000
  //               );
  //             }
  //             this.message_time.slice(0, 3);
  //           });
  //         }
  //       },
  //       err => {
  //         this.is_loading_message_rate = false;
  //         this.is_error_message_rate = true;
  //         // this.http.errCatch(err);
  //       }
  //     );
  // }

  // is_loading_msg_component;
  // msg_component;
  // is_error_msg_component;
  //
  // getMessageComponent() {
  //   this.is_loading_msg_component = true;
  //   this.is_error_msg_component = false;
  //   this.chatroomService
  //     .getMessageRate(this.chatroom.chatroom_id, this.message_scope)
  //     .subscribe(
  //       res => {
  //         this.is_loading_msg_component = false;
  //         this.is_error_msg_component = false;
  //         //TODO:main function
  //         this.msg_component = res['content']['msg_component'];
  //       },
  //       err => {
  //         this.is_error_msg_component = true;
  //         this.is_loading_msg_component = false;
  //         // this.http.errCatch(err);
  //       }
  //     );
  // }

  // is_loading_relation;
  // is_error_relation;
  // getRelation() {
  //   this.is_loading_relation = true;
  //   this.is_error_relation = false;
  //   this.chatroomService.getRelation(this.chatroom.chatroom_id).subscribe(
  //     res => {
  //       this.is_loading_relation = false;
  //       this.is_error_relation = false;
  //       //TODO:main function
  //       this.relation_option = this.echatrsOption.getRelation(
  //         res['content']['data'],
  //         res['content']['link']
  //       );
  //     },
  //     err => {
  //       this.is_loading_relation = false;
  //       this.is_error_relation = true;
  //       // this.http.errCatch(err);
  //     }
  //   );
  // }

  // is_loading_phone_rate;
  // is_error_phone_rate;
  // phone_list;
  // phone_infer;
  // phone_rate = this.echatrsOption.getPhoneRate([]);
  // getPhoneRate() {
  //   this.is_loading_phone_rate = true;
  //   this.is_error_phone_rate = false;
  //   this.chatroomService.getPhoneRate(this.chatroom.chatroom_id).subscribe(
  //     res => {
  //       this.is_loading_phone_rate = false;
  //       this.is_error_phone_rate = false;
  //       //TODO:main function
  //       this.phone_list = res['content']['phone_component'];
  //       this.phone_infer = res['content']['infer'];
  //       this.phone_rate = this.echatrsOption.getPhoneRate(this.phone_list);
  //     },
  //     err => {
  //       this.is_loading_phone_rate = false;
  //       this.is_error_phone_rate = true;
  //       // this.http.errCatch(err);
  //     }
  //   );
  // }

  // is_loading_gender;
  // is_error_gender;
  // getGender() {
  //   this.is_loading_gender = true;
  //   this.is_error_gender = false;
  //   this.chatroomService.getGender(this.chatroom.chatroom_id).subscribe(
  //     res => {
  //       this.is_loading_gender = false;
  //       this.is_error_gender = false;
  //       // console.log(time);
  //       //TODO:main function
  //       this.gender_change = this.echatrsOption.getGenderChange(
  //         res['content']['male_list'],
  //         res['content']['female_list']
  //       );
  //     },
  //     err => {
  //       this.is_loading_gender = false;
  //       this.is_error_gender = true;
  //       // this.http.errCatch(err);
  //     }
  //   );
  // }

  is_loading_geo_data;
  is_error_geo_data;
  locations;

  provinces:Array<any>;

  total_location;

  getGeoData() {
    this.is_loading_geo_data = true;
    this.is_error_geo_data = false;
    this.chatroomService.getGeoData(this.chatroom.chatroomname).subscribe(
      res => {
        this.is_loading_geo_data = false;
        this.is_error_geo_data = false;
        //TODO:main function
        this.total_location = 0;
        let locations_list = res['content']['location_list'].filter(
          item => item.value
        );
        locations_list.forEach(item => {
          this.total_location += item.value;
        });

        this.locations = locations_list.filter(loc => this.provinces.some(p => p == loc.name)).slice(0, 3);
        this.china_option = this.echatrsOption.getChinaOption(res['content']['location_list']);
      },
      err => {
        this.is_loading_geo_data = false;
        this.is_error_geo_data = true;
        // this.http.errCatch(err);
      }
    );
  }

  genderData = {};
  is_loading_gender;
  is_error_gender;
  getGender(){
    this.chatroomService.getGenderData(this.chatroom.chatroomname).subscribe(res =>{
      let data = res['content'];
      this.genderData = {
        male:Math.round(100*data['male']/this.chatroom.member_count),
        female:Math.round(100*data['female']/this.chatroom.member_count),
        unknown:Math.round(100*data['unknown']/this.chatroom.member_count),
      }
    })
  }

  // life_cycle: number = 0;
  // suggestion: string;
  // getLifeCycle() {
  //   this.chatroomService.getLiftCycle(this.chatroom.chatroom_id).subscribe(
  //     res => {
  //       this.life_cycle = res['content']['life_cycle'];
  //       this.suggestion = res['content']['suggestion'];
  //     },
  //     err => {
  //       // this.http.errCatch(err);
  //     }
  //   );
  // }

  // changeExceptionScope(day) {
  //   if (day != this.exception_scope) {
  //     if (this.ob_exception_list) this.ob_exception_list.unsubscribe();
  //     this.exception_scope = day;
  //     this.getExceptionsList();
  //   }
  // }

  // is_loading_exception_list;
  // is_error_exception_list;
  // exception_list_option = this.echatrsOption.getExceptionListOption();
  // exception_scope = 7;
  // ob_exception_list;
  //
  // getActiveLineAll() {
  //   this.getActiveLine();
  // }
  // getExceptionsList() {
  //   this.is_loading_exception_list = true;
  //   this.is_error_exception_list = false;
  //   this.ob_exception_list = this.chatroomService
  //     .getExceptionList(this.chatroom.chatroom_id, this.exception_scope)
  //     .subscribe(
  //       res => {
  //         this.is_loading_exception_list = false;
  //         this.is_error_exception_list = false;
  //         //TODO:main function
  //         this.exception_list_option = this.echatrsOption.getExceptionListOption(
  //           res['content']['in_count_list'],
  //           res['content']['out_count_list'],
  //           res['content']['total_count_list']
  //         );
  //       },
  //       err => {
  //         this.is_loading_exception_list = false;
  //         this.is_error_exception_list = true;
  //       }
  //     );
  // }
  //
  // is_loading_active_line;
  // is_error_active_line;
  // today_list = [];
  // yes_list = [];
  // active_line_option = this.echatrsOption.getActiveLineOption();
  // getActiveLine() {
  //   this.is_loading_active_line = true;
  //   this.is_error_active_line = false;
  //   this.chatroomService.getActiveList(this.chatroom.chatroom_id).subscribe(
  //     res => {
  //       this.is_loading_active_line = false;
  //       this.is_error_active_line = false;
  //       //TODO:main function
  //       this.today_list = res['content']['today_list'];
  //       this.yes_list = res['content']['yes_list'];
  //       this.active_line_option = this.echatrsOption.getActiveLineOption(
  //         this.today_list,
  //         this.yes_list
  //       );
  //     },
  //     err => {
  //       this.is_loading_active_line = false;
  //       this.is_error_active_line = true;
  //     }
  //   );
  // }
}



// WEBPACK FOOTER //
// ./src/components/chatroom-portrait/chatroom-portrait.ts